import responsiveImage from './responsive-image';

const renderProductCard = (product, helpers, collectionHandle) => {
  const productLink = product.__tagalys_fields.link;
  const productPrice = helpers.getPrice ? helpers.getPrice(product) : product.price;
  const productCompareAtPrice = helpers.getCompareAtPrice
    ? helpers.getCompareAtPrice(product)
    : product.compare_at_price;

  // Product Images
  const imgSizes =
    '(min-width: 1351px) calc(1350px / 4), (min-width: 992px) calc(100vw / 4), (min-width: 768px) calc(100vw / 3), 50vw';
  const imgAspectRatio = 'portrait';
  const imgDefaultAlt = product.title;

  let featuredImage = product.images[0];
  let secondaryImage = product.images[1];

  if (collectionHandle) {
    const imagesAlt = product.images.reduce((accumulator, image) => {
      if (image.alt) {
        accumulator += image.alt;
      }
      return accumulator;
    }, '');

    if (imagesAlt?.includes(collectionHandle)) {
      const imagesReverse = [...product.images].reverse();
      let foundCustomImage = false;

      for (const image of imagesReverse) {
        if (!image.alt) continue;

        const imageAlt = image.alt.split(',');

        for (const item of imageAlt) {
          if (item === collectionHandle) {
            featuredImage = image;
            secondaryImage = product.images[0];
            foundCustomImage = true;
            break;
          }
        }

        if (foundCustomImage) {
          break;
        }
      }
    }
  }

  let featuredImageRender = null;
  if (featuredImage) {
    const featuredImageAlt = featuredImage.alt || imgDefaultAlt;
    featuredImageRender = `<div class="product-card__image">
      ${responsiveImage(featuredImage, featuredImageAlt, 800, true, imgSizes, imgAspectRatio)}
    </div>`;
  }

  let secondaryImageRender = null;
  if (secondaryImage) {
    const secondaryImageAlt = secondaryImage.alt || imgDefaultAlt;
    secondaryImageRender = `<div class="product-card__image product-card__image--secondary">
      ${responsiveImage(secondaryImage, secondaryImageAlt, 800, true, imgSizes, imgAspectRatio)}
    </div>`;
  }

  // Product Badge
  const showCustomBadges = window.theme?.product?.showCustomBadges;
  const showSoldOutBadges = window.theme?.product?.showSoldOutBadges;
  const showOnSaleBadges = window.theme?.product?.showOnSaleBadges;
  const customBadgeLabel = product.metafields?.badge?.label?.value;
  const customBadgeBgColour = product.metafields?.badge?.background_colour?.value;
  const customBadgeTextColour = product.metafields?.badge?.text_colour?.value;
  let badge = '';

  if (showCustomBadges && customBadgeLabel) {
    let badgeStyle = '';
    if (customBadgeBgColour) {
      badgeStyle += `background-color:${customBadgeBgColour};`;
    }
    if (customBadgeTextColour) {
      badgeStyle += `color:${customBadgeTextColour};`;
    }
    badge = `<div class="badge" ${badgeStyle ? `style="${badgeStyle}"` : ''}>${customBadgeLabel}</div>`;
  } else if (showSoldOutBadges && !product.available) {
    badge = `<div class="badge badge--sold-out">${window.theme?.strings?.product?.soldOutBadge}</div>`;
  } else if (showOnSaleBadges && productCompareAtPrice > productPrice) {
    badge = `<div class="badge badge--sale">${window.theme?.strings?.product?.saleBadge}</div>`;
  }

  // Product Variants
  const sizeOptionIndex = product.options_with_values.findIndex((option) => option.name.toLowerCase() === 'size');

  let variants = '';
  if (sizeOptionIndex > -1) {
    product.variants.forEach((variant, index) => {
      const variantClass = `product-card__variant ${!variant.available ? 'product-card__variant--disabled' : ''}`;
      const variantURL = `${productLink}?variant=${variant.id}`;
      variants += `<a class="${variantClass}" href="${variantURL}">${variant[`option${sizeOptionIndex + 1}`]}</a>`;
    });
  }

  const hasMoreColours = product.metafields?.details?.more_colours;

  const firstAvailableVariant = product.variants.find((variant) => variant.available);

  const currentVariant = firstAvailableVariant || product.variants[0];

  return `
    <product-card class="product-card">
      <div class="product-card__images">
      ${
        featuredImageRender
          ? `
          <div class="product-card__featured-image">
            <a href="${productLink}">
              ${featuredImageRender}
              ${secondaryImageRender ? secondaryImageRender : ''}
            </a>
          </div>
          `
          : ''
      }
      ${
        window.theme.productCard.enableWishlist
          ? `
            <button
              class="product-card__wishlist btn-none swym-button swym-add-to-wishlist-view-product product_${
                product.id
              }"
              data-with-epi="true"
              data-swaction="addToWishlist"
              data-product-id=${product.id}
              data-variant-id=${product.variants[0].id}
              data-product-url=${productLink}
              aria-label=${window.theme?.strings?.wishlistAdd ?? 'Add to wishlist'}
            >
              <svg aria-label="Wishlist icon" class="icon icon-wishlist" width="17" height="17" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg" fill="none"><path d="M2.086 4.108c-.344.35-.617.766-.804 1.224a3.832 3.832 0 0 0 0 2.888c.187.458.46.874.804 1.224L8.496 16l6.418-6.548c.344-.35.617-.766.804-1.224a3.83 3.83 0 0 0 0-2.888 3.772 3.772 0 0 0-2.003-2.044 3.626 3.626 0 0 0-2.831 0 3.7 3.7 0 0 0-1.2.82L8.505 5.32l-1.19-1.212a3.684 3.684 0 0 0-1.198-.82 3.626 3.626 0 0 0-2.831 0c-.45.19-.857.47-1.2.82Z" stroke="currentColor" stroke-width="1.5" vector-effect="non-scaling-stroke"/></svg>
            </button>
          `
          : ''
      }

        ${badge ? `<div class="product-card__badge">${badge}</div>` : ''}
      </div>
      <div class="product-card__meta">
        ${
          product.metafields?.okendo?.StarRatingSnippet
            ? `<div data-oke-star-rating data-oke-reviews-product-id="shopify-${product.id}">
                ${product.metafields.okendo.StarRatingSnippet.value}
              </div>`
            : ''
        }

        <div class="product-card__text">
          <h4 class="product-card__title text--regular text--small-max-md">
            <a href="${productLink}">${product.title}</a>
          </h4>

          <div class="product-card__price text--regular text--small-max-md">
            <a href="${productLink}">

              ${
                helpers.isProductPricesLoading && helpers.isProductPricesLoading()
                  ? ``
                  : `
                  ${
                    product.price_varies
                      ? `
                        <span
                          >${window.theme?.strings?.product?.priceFrom?.replace(
                            '{{ price }}',
                            helpers.formatCurrency(product.price_min)
                          )}
                        </span>
                      `
                      : `
                        ${
                          helpers.isProductOnSale(productCompareAtPrice, productPrice)
                            ? `
                              <span class="visually-hidden">${window.theme?.strings?.product?.regularPrice}</span>
                              <s data-compare-price>${helpers.formatCurrency(productCompareAtPrice)}</s>
                            `
                            : ''
                        }
                        <span data-product-price
                          ${
                            helpers.isProductOnSale(productCompareAtPrice, productPrice)
                              ? 'class="product-card__sale-price"'
                              : ''
                          }
                        >
                          ${helpers.formatCurrency(productPrice)}
                        </span>
                      `
                  }
                `
              }
            </a>
          </div>
        </div>
        ${variants ? `<div class="product-card__variants text--small text--condensed">${variants}</div>` : ''}

        ${
          hasMoreColours
            ? `<p class="product-card__stitching"><a href="${productLink}">${window.theme?.strings?.product?.moreColours}</a></p>`
            : ''
        }
      </div>
    </product-card>`;
};

export default renderProductCard;
